import { render, staticRenderFns } from "./PageServiceModelRead.vue?vue&type=template&id=303e28c6&scoped=true&"
import script from "./PageServiceModelRead.vue?vue&type=script&lang=js&"
export * from "./PageServiceModelRead.vue?vue&type=script&lang=js&"
import style0 from "./PageServiceModelRead.vue?vue&type=style&index=0&id=303e28c6&scoped=true&lang=css&"
import style1 from "./PageServiceModelRead.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303e28c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VIcon})
